import React, { Component, Fragment} from 'react';
import {lang} from 'js/Core/lang';
import TruncateMarkup from 'react-truncate-markup';
class ProductsList extends Component {
    constructor(props){
        super(props);
    }
    updateDimensions() {
        
    }
    componentDidMount() {
        this.updateDimensions();                  
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render() {
        let {products, selectedProducts } = this.props;
        return (
            <div className="container-product">
                <div className="product-text-note label-header">{lang.txt.header_note_timeline}</div>
                <h3  className="cor_ttl">{lang.txt.label_header_menu_yuri}</h3>
                <table className="list-products">
                    <tbody>
                        {
                            products.map((e, i) => {
                                let check = selectedProducts.find(item => item === e.id)
                                return (
                                    <tr key={i}>
                                        <td className="name">
                                            <p>{e.productName}</p>
                                            <div className="short-desc">
                                                {
                                                    e.shortDescription !== '' ? <TruncateMarkup lines={2}><div>{e.shortDescription}</div></TruncateMarkup> : ''
                                                }                                                                                        
                                            </div>
                                        </td>
                                        <td  className="price">
                                            <span>{lang.label.yen}{e.price.toLocaleString()}{e.priceType === 'CUSTOMIZE' && '～'}</span>
                                        </td>
                                        <td  className="button-submit">
                                            <button className={`btn-select-product${check ? ' selected' : ''}`} onClick={ev => this.props.handleSelectproduct(e.id, check ? true : false)}>{lang.label.reservation}</button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ProductsList;